var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenTea = function SvgGreenTea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#green-tea_svg__a)",
    d: "M63 161.5c.2 1.672 8.49 2.773 10.252 2.447s6.328-1.643 7.85-1.189 3.845-1.095 4.565-.687 3.2.326 5.447-2.039 6.328-.49 7.209-.408 2.162-.9 3.2-1.387 3.364 1.06 3.844.734 2.564-2.365 3.765-2.365 8.41 1.549 9.451.979.441-1.754 1.522-1.958 13.777-2.936 14.578-3.344.481-1.55 2.083-2.366 7.288-1.386 8.009-1.876-.961-1.386-.841-2.08 5.887-2.243 6.688-2.732.881-2.121 2.443-2.162 3.244.694 3.645 0 .08-2.161 1.842-3.058 14.818 2.039 15.7 1.223-.48-2.692.561-3.1 7.689.245 8.09-.407-.6-2.692.4-3.059 6.648.449 6.889-.367-.361-1.835.24-2.162 4.045.571 4.325.286-.481-2.121 0-2.2 3.164 1.59 3.364 1.386a1.98 1.98 0 0 0 0-1.59c-.24-.449.921-1.224 1.642-1.224s2.8.49 2.643-.652a3.925 3.925 0 0 1 2.724-3.426c1.361-.2 2.322-2.61 1.642-3.222s-4.326-3.14-5.207-3.263-9.651 1.55-11.373 1.061-5.127-4.568-6.248-5.1-1.8-.2-2.163-1.061.441-3.058-1.642-3.67-14.1-1.754-15.459-1.387-9.892 4.69-11.013 4.405-3.564-1.387-5.086-1.224-16.02 3.956-17.942 5.384-14.978 7.749-16.059 8.564-8.811 8.442-11.7 8.769c-2.89.327-4.846 2.447-5.927 2.528s-4.445-.326-5.406.082-2.083 4.445-2.8 4.771-8.01 5.914-8.891 7.26-6.447 8.32-7.65 8.646c-1.201.326-2.362 2.692-3.323 2.895s-5.96 2.693-5.883 3.345"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "green-tea_svg__a",
    x1: 62.999,
    x2: 206.996,
    y1: 135.004,
    y2: 135.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgGreenTea;